import React from "react";
import ViewCoursesGroup from "./Group";
import Page from "~/components/parts/Page";

const Skeleton = () => (
  <div className="flex flex-col items-start gap-5">
    <div className="h-14 w-1/2 animate-pulse rounded-md bg-slate-100 duration-75"></div>
    <div className="grid w-full grid-cols-1 gap-4 md:auto-rows-fr md:grid-cols-2 lg:grid-cols-3">
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          className="h-28 animate-pulse rounded-md bg-slate-100 duration-75 md:h-36"
        />
      ))}
    </div>
  </div>
);

const ViewCourses = ({ groups = [], isLoading, subtitle, user }) => {
  return (
    <Page title="Courses" subtitle={subtitle}>
      <div className="flex flex-col gap-12">
        {isLoading ? (
          <>
            <Skeleton />
            <Skeleton />
            <Skeleton />
          </>
        ) : (
          groups.map((group, index) => (
            <ViewCoursesGroup
              key={group.title}
              {...group}
              isLoading={isLoading}
              positionOnPage={index + 1}
            />
          ))
        )}
      </div>
      {!isLoading && (
        <div className="mb-8 flex flex-col items-start gap-6">
          <h3 className="m-0 text-xl">Can't find what you are looking for?</h3>
          {!user && (
            <a
              className="text-xl text-blue-500 underline underline-offset-4 hover:decoration-[3px]"
              href="/login.php?url=/view-courses.php"
            >
              Login to view your courses
            </a>
          )}
          <a
            className="text-xl text-blue-500 underline underline-offset-4 hover:decoration-[3px]"
            href="/browse-courses.php"
          >
            View all published courses
          </a>
        </div>
      )}
    </Page>
  );
};

export default ViewCourses;
